import api from '../../../api';

export function getCustomerData(key) {
	return api.post(`/search-orders`, { key });
}

export function getCrmCategories() {
	return api.get('/get-crm-category');
};

export function getAllCrmCategories() {
  return api.get('/get-all-crm-category');
}

export function postTicket(payload) {
	return api.post('/v2/create-ticket', payload);
};

export const getTicketConfig = caseId => {
	return api.get(`/get-ticket-config/${caseId}`);
};

export const getTicketSlot = (subcategory = 'customer_complaints') => {
	return api.get(`/get-ticket-slots/${subcategory}`);
};

export const getCxComplaintTicket = (startDate, endDate, PageNumber, query) => {
    return api.get(`/get-cx-complaints-ticket/${startDate}/${endDate}?pageNumber=${PageNumber}${query && query.length ? `&${query}` : ``}`);
};
